export var DecisionType;
(function (DecisionType) {
    DecisionType["STRING"] = "String";
    DecisionType["BOOLEAN"] = "Boolean";
    DecisionType["INTEGER"] = "Integer";
})(DecisionType || (DecisionType = {}));
export function getDecisionValueString(decision) {
    if (!decision ||
        decision.type !== DecisionType.STRING ||
        typeof decision.value !== 'string') {
        return null;
    }
    return decision.value;
}
export function getDecisionValueInteger(decision) {
    if (!decision ||
        decision.type !== DecisionType.INTEGER ||
        typeof decision.value !== 'number') {
        return null;
    }
    return decision.value;
}
export function getDecisionValueBoolean(decision) {
    if (!decision || decision.type !== DecisionType.BOOLEAN) {
        return null;
    }
    return typeof decision.value === 'boolean'
        ? decision.value
        : decision.value === 'true';
}
